import { useStore } from '@nanostores/react';
import { OpenAPI } from '../../api/core/OpenAPI';
import { request as __request } from '../../api/core/request';

export const QuickbooksOAuthRedirectHandler = () => {
  const org = useStore($org);
  const effectRunRef = useRef(false);

  const [message, setMessage] = useState(
    'Processing Quickbooks Authentication...',
  );

  useEffect(() => {
    if (!org || effectRunRef.current) return; // Prevent running the effect again
    effectRunRef.current = true;
    const handleCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const realmId = urlParams.get('realmId');
      const state = urlParams.get('state');
      const redirectUri = `${window.location.origin}/quickbooks_oauth_redirect`; // Your actual redirect URI
      if (!code) {
        console.error('Invalid state or missing code/state');
        return;
      }

      const body: {
        Code: string;
        RedirectURI: string;
        RealmId: string;
        State: string;
        OrgId?: string;
      } = {
        Code: code,
        RedirectURI: redirectUri,
        RealmId: realmId ?? '',
        State: state ?? '',
      };

      if (org) {
        body.OrgId = org.id;
      }

      try {
        await __request(OpenAPI, {
          method: 'POST',
          url: `/integrations/quickbooks/getAccessToken`,
          body,
          mediaType: 'application/json',
        });

        setMessage('Authentication successful, redirecting to integrations...');
        window.location.href = `/settings?activeNav=integrations`;
      } catch (error) {
        setMessage('Authentication unsuccessful, please try again!');
        window.location.href = `/settings?activeNav=integrations`;
        console.error('Error during authentication callback', error);
      }
    };

    handleCallback();
  }, [org]);

  return (
    <div>
      <p>{message}</p>
    </div>
  );
};
